const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Assessment Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {assessments} assessments the resource defined to manage assessments
 */
app.directive('assessmentViewer', ['Application', 'Authorization', 'Analyze', 'Assessments', 'AssessmentLib', 'Assignments', 'UserAssessments', 'AssessmentScores', '$translate', '$q', function (Application, Authorization, Analyze, Assessments, AssessmentLib, Assignments, UserAssessments, AssessmentScores, $translate, $q) {
  return {
    restrict: 'E',
    scope: {
      checkFull: '@?',
      fullData: '=?',
      contentId: '=?',
      specialClose: '&?',
      trackId: '=?',
      journeyId: '=?',
      returnToJourney: '&?',
      userTrack: '=?',
      previousAvailable: '=?',
      trackNext: '&?',
      onComplete: '&?',
      nextAvailable: '&?',
      sequentialTrack: '=?',
      lastCourse: '=?',
      progression: '=?'
    },
    template: require('../../../templates/directives/assessments/assessment-viewer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var adminRoles = ['admin', 'creator'];
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = adminRoles.indexOf(self.user.role) !== -1;
      self.type = 'assessment';
      self.assessment = {};
      self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
      self.lastCourse = false;
      self.translations = {};
      self.showCertificate = false;
      self.closeCertificate = function() {
        self.showCertificate = false;
      };

      self.progression = $scope.progression;

      self.scrollToContent = function(e){
       e.preventDefault();
      };

      self.url = Application.navigation.getUrl();
      self.inTrack = new RegExp('track').test(self.url) || !!$scope.trackId;
      self.inJourney = !!$scope.journeyId;
      self.tracking = new Application.Tracking(Analyze, moment, 'assessment', $scope.trackId || null);
      if (self.inTrack && !$scope.trackId) {
        var trackWatch = $scope.$watch('trackId', function(newVal) {
          if (newVal) {
            self.tracking.setTrackId($scope.trackId);
            trackWatch();
          }
        });
      } else {
        self.tracking.setTrackId($scope.trackId);
      }

      self.close = function(){
        if (self.inTrack) {
          var location = Application.navigation.getUrl().split('#/')[1];
          if (!location) {
            return;
          }
          location = location.split('/assessments')[0];
          if (!location) {
            return;
          }
          Application.navigation.goTo(location)
          return;
        }

        if ($scope.specialClose) {
          $scope.specialClose();
          return;
        }

        if (!self.backLocation) {
          Application.navigation.back();
          return;
        }
        var location = self.backLocation.split('/#/');
        if (location.length !== 2) {
          Application.navigation.back();
          return;
        }
        Application.navigation.goTo(location[1]);
      };

      self.info = {
        answeredTable: {},
        introPage: false,
        showIntroPage: false,
        numberAnswered: 0,
        numberTotal: 0,
        currentPage: 0,
        userResponses: {},
        pageList: [],
        resultsAssessment: null,
        gradedResponses: null,
        userScoredPercent: null,
        showResultsLoading: false,
        changePage: function(sign) {
          Application.scrollTop();
          if (sign === '-') {
            if(self.info.currentPage > 0) {
              self.info.currentPage--;
              return;
            }
            if (self.info.currentPage === 0 && self.info.introPage) {
              self.info.showIntroPage = true;
              return;
            }
          }
          if (sign === '+') {
            if (self.info.showIntroPage) {
              self.info.showIntroPage = false;
              self.info.currentPage = 0;
              return;
            }
            if (self.info.currentPage < (self.info.pageList.length - 1)) {
              self.info.currentPage++;
              return;
            }
          }
        },
        sortByProp: function(arr, prop) {
          arr.sort(function(a, b) {
            if (a[prop] > b[prop]) {
              return 1;
            }
            if (a[prop] < b[prop]) {
              return -1;
            }
            return 0;
          });
        },
        updateAnswered: function() {
          if (!self.assessment || !self.assessment.questions || !self.assessment.questions.length) {
            return;
          }
          self.info.numberAnswered = 0;
          self.assessment.questions.forEach(function(question) {
            self.info.answeredTable[question.id] = false;
            if (question && question.id && self.info.userResponses && self.info.userResponses[question.id]) {
              if (AssessmentLib.helpers.isAnswered(question, self.info.userResponses[question.id])) {
                self.info.numberAnswered++;
                self.info.answeredTable[question.id] = true;
              }
            }
          });
        },
        parseShowResults: function() {
          if ($scope.checkFull) {
            return;
          }
          if (!self.userAssessment || !self.userAssessment.scores || !self.userAssessment.scores.length) {
            // message about no scores found
            return;
          }
          var lastScore = self.userAssessment.scores[self.userAssessment.scores.length - 1];
          var fields = 'max_percentage';
          if (self.info.currentState.indexOf('results') !== -1) {
            fields += ',assessment_when_scored,graded_responses';
          }
          self.info.showResultsLoading = true;
          AssessmentScores.get({subresource: lastScore, fields: fields}).$promise
          .then(function(score) {
            self.info.showResultsLoading = false;
            if (score.max_percentage && (score.max_percentage <= 100 || score.max_percentage >= 0)) {
              self.info.userScoredPercent = Math.floor(score.max_percentage);
            }
            if (self.info.currentState.indexOf('results') !== -1) {
              self.info.resultsAssessment = score.assessment_when_scored;
              self.info.gradedResponses = score.graded_responses;
            }
          }).catch(function(error) {
            self.info.showResultsLoading = false;
            console.log('error: ', error)
            // Show error message.
          });

        },
        retake: function() {
          self.userAssessment.in_progress_responses = {};
          self.info.userResponses = self.userAssessment.in_progress_responses;
          self.info.currentPage = 0;
          if (self.info.introPage) {
            self.info.showIntroPage = true;
          }
          self.parseUserAssessment();
        },
        checkLastCourse: function () {
          self.lastCourse = false;
          if ($scope.lastCourse && $scope.lastCourse.assessment && $scope.lastCourse.assessment._id && $scope.lastCourse.assessment._id === $scope.contentId) {
            self.lastCourse = true;
          }
        }
      };

      self.resetInfo = function() {
        self.assessment = {};
        self.userAssessment = null;
        self.info = Object.assign(self.info, {
          answeredTable: {},
          introPage: false,
          showIntroPage: false,
          numberAnswered: 0,
          numberTotal: 0,
          currentPage: 0,
          userResponses: {},
          pageList: [],
          resultsAssessment: null,
          gradedResponses: null,
          userScoredPercent: null,
          showResultsLoading: false
        });
        self.info.checkLastCourse();
      };

      self.comms = {
        creatUserAssessment: function() {
          if ($scope.checkFull) {
            return;
          }
          // create user assessment here - delay is ok.
          UserAssessments.create({user: self.user._id, assessment: $scope.contentId}).$promise
          .then(function(userAssessment) {
            self.userAssessment = userAssessment;
            if (userAssessment.in_progress_responses) {
              self.info.userResponses = userAssessment.in_progress_responses;
            }
          }).catch(function(error) {
            console.log('error in creating user assessment');
            // handle error
          });
        },
        updateUserResponses: function(submit) {
          if ($scope.checkFull) {
            self.info.updateAnswered();
            return;
          }

          UserAssessments.update({
            subresource: self.userAssessment._id,
            fields: 'in_progress_responses'
          }, {in_progress_responses: self.info.userResponses}).$promise
          .then(function(userAssessment) {
            if (userAssessment.in_progress_responses) {
              self.info.userResponses = userAssessment.in_progress_responses;
            }
            self.info.updateAnswered();
            if (submit) {
              self.comms.submit();
            }
            Authorization.setActive();
          }).catch(function(error) {
            console.log('error in updating user assessment');
            // handle error
          });
        },
        submit: function() {
          if ($scope.checkFull) {
            return;
          }
          self.info.submitting = true;
          const completionContexts = [];
          if (self.inTrack && $scope.trackId) {
            completionContexts.push({key: 'track', value: $scope.trackId});
          }
          if (self.inJourney) {
            completionContexts.push({key: 'journey', value: $scope.journeyId});
          }
          UserAssessments.score({subname: self.userAssessment._id}, {completionContexts: completionContexts}).$promise
          .then(function(results) {
            self.userAssessment = results.userAssessment;
            self.parseUserAssessment();
            if (self.inTrack && (self.info.currentState === 'passed' || self.info.currentState === 'passed-results' || self.info.currentState === 'passed-grade')) {
              $scope.onComplete();
            }
            self.info.submitting = false;
          }).catch(function(error) {
            self.info.submitting = false;
            console.log('error: ', error);
            // Handle errors with provided messages for detail
          });
        }
      };

      self.parseUserAssessment = function() {
        self.info.currentState = 'progress';
        if (self.userAssessment.passed) {
          // Show passed page
          self.info.currentState = 'passed';
          // self.info.showPassed = true;
          if (self.assessment.show_user_correct || self.assessment.show_user_grade) {
            if (self.assessment.show_user_grade) {
              self.info.currentState = 'passed-grade';
              if (self.assessment.video_assessment || self.assessment.file_assessment) {
                self.info.currentState = 'passed-results';
              }
            }
            if (self.assessment.show_user_correct) {
              self.info.currentState = 'passed-results';
            }
            self.info.parseShowResults();
          }
          return;
        }
        if (self.userAssessment.awaiting_manual_grade) {
          self.info.currentState = 'waiting';
          // Notify awaiting manual grade and do not progress or allow change of answers
          self.info.showManualGrading = true;
          return;
        }
        if (self.userAssessment.scores && self.userAssessment.scores.length) {
          // Check against assessment attempts allowed
          if ((self.assessment && !self.assessment.allow_retake) || (self.assessment && self.assessment.allow_retake && (self.assessment.number_of_retakes + 1) <= self.userAssessment.scores.length)) {
            self.info.currentState = 'failedMax';
            if (self.assessment.show_user_correct_after_fail) {
              self.info.currentState = 'failedMax-results';
              self.info.parseShowResults();
            }
            return;
          }
          if (!self.userAssessment.in_progress_responses) {
            self.info.currentState = 'failedAttempt';
            if (self.assessment.show_user_correct_after_fail) {
              self.info.currentState = 'failedAttempt-results';
              self.info.parseShowResults();
            }
            return
          }
        }
        self.info.userResponses = self.userAssessment.in_progress_responses || {};
        self.info.updateAnswered();
      };

      self.parse = function() {
        if (!self.assessment || !self.assessment.questions || !self.assessment.questions.length) {
           return;
        }

        if (self.assessment.video_assessment || self.assessment.file_assessment) {
          return;
        }

        var pages = {};
        self.info.answeredTable = {};
        self.assessment.questions.forEach(function(item) {
          if (!item.page && item.page !== 0 || !item.id) {
            return;
          }

          self.info.answeredTable[item.id] = false;

          if (!pages[item.page]) {
            pages[item.page] = [];
          }

          pages[item.page].push(item);
          self.info.numberTotal++;
        });

        for (var key in pages) {
          self.info.sortByProp(pages[key], 'position');
          self.info.pageList[key] = pages[key];
        }
      };

      self.returnTrack = function() {
        if ($scope.trackNext && $scope.nextAvailable && $scope.nextAvailable()) {
          $scope.trackNext();
          return;
        }

        Application.navigation.goTo('/view/tracks/' + $scope.trackId);
      };

      self.track = {
        next: function() {
          $scope.trackNext();
        },
        previous: function() {
          $scope.trackNext({id: 'previous'});
        }
      }

      self.initialize = function () {
        self.resetInfo();
        self.info.currentState = 'progress';
        if (!$scope.contentId && !$scope.fullData) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }

        function onInit(assessment, userAssessment) {
          self.assessment = assessment;

          // If complete and if users are to be shown results get the information here
          if (userAssessment) {
            self.userAssessment = userAssessment;
            self.parseUserAssessment();
            if (self.info.currentState === 'passed' || self.info.currentState === 'passed-grade' || self.info.currentState === 'passed-results') {

              // No need for asssment parsing in its current state.
              return;
            }
          }

          self.parse();

          self.info.introPage = false;
          self.info.showIntroPage = false;
          if (!self.assessment.video_assessment && !self.assessment.file_assessment && self.assessment.description) {
            if (self.assessment.hide_cover) {
              return;
            }
            self.info.introPage = true;
            if (self.info.currentState === 'progress') {
              self.info.showIntroPage = true;
            }
          }
        };

        if ($scope.checkFull) {
          if (!$scope.contentId || !$scope.fullData._id) {
            onInit($scope.fullData, {in_progress_responses: {}});
            return;
          }

          UserAssessments.find({user: self.user._id, assessment: $scope.fullData._id, fields: 'user,assessment,in_progress_responses,scores,passed,awaiting_manual_grade,date_passed', notStarted: 'true'}).$promise
          .then(function(userAssessments) {
            var ua = userAssessments && userAssessments.length && userAssessments[0] || null;
            onInit($scope.fullData, ua);
            if (!self.userAssessment) {
              self.comms.creatUserAssessment();
            }
          });
          return;
        }

        var promises = [
         // Revisit API for a get that specifically removes the score in the reponse do deter cheating
          Assessments.take({
            subname: $scope.contentId,
            fields: 'company,user,questions,title,description,archived,private,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,image,banner_image,cover_justification,featured_justification,explore_hide,tags,published,allow_retake,number_of_retakes,show_user_correct,show_user_correct_after_fail,show_user_grade,video_assessment,file_assessment,creator_name,certificate,certificate_data,hide_cover',
            'user-populate': 'first_name,last_name,email'
          }).$promise,
          UserAssessments.find({user: self.user._id, assessment: $scope.contentId, fields: 'user,assessment,in_progress_responses,scores,passed,date_passed,awaiting_manual_grade', notStarted: 'true'}).$promise
        ];

        if (!self.user || !self.user.role || !self.user._id) {
          Application.navigation.goTo('/explore');
          return;
        }

        if (self.user.role !== 'admin') {
          promises.push(Assignments.find({
            assignee: self.user._id,
            '$or': '4,assessment,' + $scope.contentId + ',assigned_content.content_id,' + $scope.contentId,
            fields: 'assignee,assessment'
          }).$promise)
        }

        var allowAccess = function(assignments, assessment) {
          if ($scope.trackId || $scope.journeyId) {
            return true;
          }

          if (self.user.role === 'admin') {
            return true;
          }

          if (assignments && assignments.length) {
            return true;
          }

          if (self.user.role === 'user' && (!assignments  || assignments.length === 0)) {
            return false;
          }

          
          if (self.user.role === 'creator') {
            if (assessment && assessment.user && assessment.user.toString() === self.user._id.toString()) {
              return true;
            }
          }
          

          return false;
        };

        $q.all(promises).then(function (data) {
          var assessment = data[0];
          var userAssessment = data[1] && data[1].length && data[1][0] || null;

          if(!allowAccess(data[2], assessment)) {
            Application.messaging.addMessage({type: 'error', text: self.translations['assessViewer.permission_error'], duration: 5});
            Application.navigation.goTo('/explore');
            return;
          }
          // Order of this statement is very important
          onInit(assessment, userAssessment);
          Analyze.record({resource: 'views'}, {content: assessment._id, content_type: 'assessment'});
          Application.analyticsProvider.trackEvent('assessment_viewed', {content: assessment._id, content_type: 'assessment', title: assessment.title});

          if (!self.userAssessment) {
            self.comms.creatUserAssessment();
          }

          self.tracking.start(self.assessment);
        }, function (error) {
          console.log('Error occured getting assements', $scope.contentId, error);
        });
      };

      $scope.$on('$destroy', function() {
        self.tracking.end();
      });

      $translate([
        'assessViewer.permission_error'
      ]).then(function (translations) {
        self.translations = translations;
        self.initialize();
      });

      if (self.inTrack) {
        $scope.$watch('contentId', function(newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            self.initialize();
          }
        });
      }
    }],
    controllerAs: 'viewing'
  }
}]);